import { render, staticRenderFns } from "./TreasureHallModal.vue?vue&type=template&id=4514fa3f&scoped=true"
import script from "./TreasureHallModal.vue?vue&type=script&lang=js"
export * from "./TreasureHallModal.vue?vue&type=script&lang=js"
import style0 from "./TreasureHallModal.vue?vue&type=style&index=0&id=4514fa3f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514fa3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4514fa3f')) {
      api.createRecord('4514fa3f', component.options)
    } else {
      api.reload('4514fa3f', component.options)
    }
    module.hot.accept("./TreasureHallModal.vue?vue&type=template&id=4514fa3f&scoped=true", function () {
      api.rerender('4514fa3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/commands/TreasureHallModal.vue"
export default component.exports